// Must stay the first import, see zodConfig.ts
import "../../src/zodConfig";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { AuthProvider } from "../../src/auth/AuthProvider";
import { RuntimeConfigProvider } from "../../src/config/RuntimeConfigProvider";
import { InternationalizationProvider } from "../../src/i18n/InternationalizationProvider";
import { AdminPage } from "./admin/AdminPage";
import { ColleaguePanel } from "./admin/ColleaguePanel";
import { RequireAdmin } from "./admin/RequireAdmin";
import { OwnPortraitPage } from "./portrait/OwnPortraitPage";
import { PortraitsApp } from "./PortraitsApp";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <InternationalizationProvider>
      <QueryClientProvider client={queryClient}>
        <RuntimeConfigProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route path="/" element={<PortraitsApp />}>
                  <Route index element={<OwnPortraitPage />} />
                  <Route
                    path="admin"
                    element={
                      <RequireAdmin>
                        <AdminPage />
                      </RequireAdmin>
                    }
                  >
                    <Route path=":uidNumber" element={<ColleaguePanel />} />
                  </Route>
                </Route>
                <Route path="callback" />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </RuntimeConfigProvider>
      </QueryClientProvider>
    </InternationalizationProvider>
  </StrictMode>,
);
